import { inject } from "@angular/core";
import { AuthService } from "../auth/services/auth.service";
import {Subscription } from "rxjs";


export const authPublicGuardActivate : () => true | Subscription = ()=>{
  const authService = inject(AuthService);

  if(!localStorage.getItem('token')) {
    return true;
  }
  const token = localStorage.getItem('token');
  return authService.checkAutentication(token!)
    .subscribe({
      next: (response)=> {
      },
      error: (err)=> {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return true;
      }
    })
}




